import { render, staticRenderFns } from "./dlgConfirm.vue?vue&type=template&id=6fb5b5be"
import script from "./dlgConfirm.vue?vue&type=script&lang=js"
export * from "./dlgConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports